var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnet-point-index"
  }, [_vm.isLoading ? _c('p', [_c('Loading')], 1) : [_c('Tabs'), _c('div', {
    staticClass: "s-p-3"
  }, [_c('div', {
    staticClass: "s-bg-white rounded rounded-2 d-flex partnet-point-index__point"
  }, [_c('div', {
    staticClass: "text-center w-50"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.currentPoints.toLocaleString()))]), _c('div', {
    staticClass: "s-text-xs"
  }, [_vm._v("我的點數")])]), _c('div', {
    staticClass: "text-center w-50"
  }, [_c('div', {
    staticClass: "s-text-secondary mb-2"
  }, [_vm._v(_vm._s(_vm.expiringPoints.toLocaleString()))]), _c('div', {
    staticClass: "s-text-xs"
  }, [_vm._v(_vm._s(_vm.expiringDate) + " 即將到期")])])])]), _c('div', {
    staticClass: "s-p-3"
  }, [_c('div', [_c('label', {
    staticClass: "field__label"
  }, [_vm._v(" 請輸入序號兌換寶雅點數 ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-input', {
    staticClass: "field__input flex-fill mr-2",
    attrs: {
      "size": "sm",
      "placeholder": "輸入優惠券代碼",
      "disabled": _vm.isExchanging
    },
    model: {
      value: _vm.serialNumber,
      callback: function callback($$v) {
        _vm.serialNumber = $$v;
      },
      expression: "serialNumber"
    }
  }), _c('button', {
    staticClass: "s-btn s-btn-primary s-btn-sm w-auto text-nowrap confirm-btn",
    attrs: {
      "disabled": _vm.isExchanging || !_vm.serialNumber
    },
    on: {
      "click": _vm.exchangeCode
    }
  }, [_vm._v(" " + _vm._s(_vm.isExchanging ? '處理中...' : '確認') + " ")])], 1)]), _vm.partnerOrganizations.length > 0 ? _c('div', {
    staticClass: "partnet-point-index__list"
  }, [_c('div', {
    staticClass: "divider"
  }, [_vm._v("可兌換")]), _vm._l(_vm.processedPartnerOrganizations, function (partnerOrg, orgIdx) {
    return _c('div', {
      key: "partner-org-".concat(orgIdx)
    }, [_c('div', {
      staticClass: "s-bg-white rounded rounded-2 d-flex align-items-center list__item mb-3",
      class: {
        'list__item--sold-out': partnerOrg.all_plans_sold_out
      },
      on: {
        "click": function click($event) {
          return _vm.navigateToPartnerOrg(partnerOrg);
        }
      }
    }, [partnerOrg.image ? _c('div', {
      staticClass: "list__image px-3"
    }, [_c('img', {
      attrs: {
        "src": partnerOrg.image,
        "alt": ""
      },
      on: {
        "error": function error($event) {
          $event.target.style.display = 'none';
        }
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "flex-fill px-3"
    }, [_c('div', {
      staticClass: "list__title mb-2"
    }, [_vm._v(_vm._s(partnerOrg.name))]), partnerOrg.available_plans.length > 0 ? [_vm._l(_vm.getDisplayExchanges(partnerOrg), function (exchange, exchIdx) {
      return _c('div', {
        key: exchIdx,
        staticClass: "s-text-xs mb-1 list__exchange"
      }, [_c('span', {
        staticClass: "s-text-primary font-weight-bold"
      }, [_vm._v(_vm._s(exchange.from.value))]), _vm._v(" " + _vm._s(exchange.from.unit) + " → "), _c('span', {
        staticClass: "s-text-primary font-weight-bold"
      }, [_vm._v(_vm._s(exchange.to.value))]), _vm._v(" " + _vm._s(exchange.to.unit) + " ")]);
    }), partnerOrg.available_plans.length > 1 ? _c('div', {
      staticClass: "s-text-xs badge badge-secondary p-1"
    }, [_vm._v("更多方案")]) : _vm._e()] : partnerOrg.all_plans_sold_out ? [_c('div', {
      staticClass: "s-text-xs text-muted"
    }, [_vm._v("序號已兌換完畢")])] : _vm._e()], 2)])]);
  })], 2) : _vm._e(), _vm.partnerOrganizations.length === 0 && !_vm.isLoading ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("目前暫無可用的兌換方案")])]) : _vm._e(), _vm.errorMessage ? _c('div', {
    staticClass: "alert alert-danger mt-3"
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e()])], _c('SuccessPopup', {
    attrs: {
      "show": _vm.showSuccessPopup,
      "message": _vm.successMessage
    },
    on: {
      "close": function close($event) {
        _vm.showSuccessPopup = false;
      }
    }
  }), _c('ErrorPopup', {
    attrs: {
      "show": _vm.showErrorPopup,
      "title": _vm.errorPopupMessage
    },
    on: {
      "close": _vm.handleErrorPopupClose
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }